import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";

export const CareersDescriptionRowContainer = styled('div')(css`
  max-width: 1070px;
  margin: 0 auto;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 50px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e8e8e8;
`)

export const CareersDescriptionText = styled('p')(css`
    ${fontSize(18)};
    ${FontNormal(300)};
    text-align: center;
    padding: 0px;
    margin: 0px;
`)
